export const UNIT_SEARCH_HISTORY_KEY = 'unit-search-history';
export const CAMPAIGN_SEARCH_HISTORY_KEY = 'campaign-search-history';

export function getSearchHistory(key: string): string[] {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.slice(0, 10) : [];
  } catch {
    return [];
  }
}

export function addSearchTerm(key: string, term: string): void {
  const trimmed = term.trim();
  if (!trimmed) return;
  const history = getSearchHistory(key);
  const deduped = [trimmed, ...history.filter((t) => t.toLowerCase() !== trimmed.toLowerCase())];
  localStorage.setItem(key, JSON.stringify(deduped.slice(0, 10)));
}

export function removeSearchTerm(key: string, term: string): void {
  const history = getSearchHistory(key);
  localStorage.setItem(key, JSON.stringify(history.filter((t) => t !== term)));
}

export function clearSearchHistory(key: string): void {
  localStorage.removeItem(key);
}
